import {spotheroGet} from 'api';
import {camelizeKeys} from 'utils/format-strings';
import {sendSentryException} from 'utils/error-handling';
import {
    GetEventDayOverviewResponse,
    EventDayOverview,
} from 'api/events/events.types';

/**
 * Formats the day overview response.
 */
const formatEventDayOverviewResponse = (data: GetEventDayOverviewResponse) => {
    const formattedData = camelizeKeys(data);

    return formattedData;
};

/**
 * Gets the events day overview for a given facility and date.
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Events/get_facilities_facility_id_events-overview_date
 */
const getEventsDayOverview = async (facilityId: number, date: string) => {
    try {
        const response = await spotheroGet<EventDayOverview>(
            `facilities/${facilityId}/events-overview/${date}/`
        );

        const formatedResponse = formatEventDayOverviewResponse(response.data);

        return formatedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default getEventsDayOverview;
